import { render, staticRenderFns } from "./DomainSingleView.vue?vue&type=template&id=2d7c8aea&"
import script from "./DomainSingleView.vue?vue&type=script&lang=js&"
export * from "./DomainSingleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d7c8aea')) {
      api.createRecord('2d7c8aea', component.options)
    } else {
      api.reload('2d7c8aea', component.options)
    }
    module.hot.accept("./DomainSingleView.vue?vue&type=template&id=2d7c8aea&", function () {
      api.rerender('2d7c8aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/domains/DomainSingleView.vue"
export default component.exports